import IParser from "@/types/IParser"
import { IFeature } from "@/models/admin/feature/feature.types"
import ParseError from "@/types/ParseError"
import { Feature } from "@/models/admin/feature/feature"
import { dayjsOrNull } from "@/helpers/dateHelper"

interface FeatureSource {
  id: number | string
  name: string
  enabled: boolean
  squadName?: string | null
  description?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

export const FeatureParser: IParser<IFeature, FeatureSource> = {
  toDomain(data: FeatureSource): IFeature {
    try {
      return new Feature(
        Number(data.id),
        data.name,
        data.enabled,
        data.squadName ?? "",
        data.description ?? null,
        dayjsOrNull(data.createdAt),
        dayjsOrNull(data.updatedAt),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
